import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import DeleteModal from "../../components/Modals/DeleteModal";
import "./allSubscriptions.css";
import logoBlue from "../../components/images/logoblue.png";
import { Link, useHistory, useParams } from "react-router-dom";
import { ArrowBack, Delete, KeyboardArrowDown } from "@material-ui/icons";
import {
  fetchSubscriptions,
  createSubscription,
  deleteSubscription,
} from "../../redux/actions/subscriptionAction.js";
import AddSubscriptionModal from "../../components/Modals/AddSubscriptionModal";

const initialState = {
  subscriptionName: "",
  cost: "",
  type: "",
  durationDays: "",
};

export default function AllSubscriptions(props) {
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [clockTypeModal, setClockTypeModal] = useState(false);
  const [selectedClockType, setSelectedClockType] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();
  const { userId } = useParams();

  const { subscriptions, loading, error } = useSelector(
    (state) => state.subscription
  );

  const clockTypes = ["clock only", "clock with stats"];

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSelectType = (val) => {
    setSelectedClockType(val);
    handleFormChange("type", val);
    setClockTypeModal(false);
  };

  const handleCreate = async () => {
    dispatch(createSubscription(initialStateForm));
    handleClose();
  };

  const toggleDelete = (id) => {
    setDeleteItemId(id);
  };

  const handleDelete = async (id) => {
    dispatch(deleteSubscription(id));
    setOpenDeleteModal(true);
  };

  useEffect(() => {
    dispatch(fetchSubscriptions());
  }, [dispatch]);

  return (
    <div className="user">
      {openDeleteModal && (
        <DeleteModal
          closeModal={setOpenDeleteModal}
          children="Subscription deleted successfully"
        />
      )}

      <div className="userHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="userTitle">All Subscriptions</h1>
        </div>
        <img className="userLogo" src={logoBlue} alt="logo" width="150px"></img>
      </div>

      <div className="allSubsView">
        <div className="allSubsViewR1">
          <div className="allSubsName">Clock Only</div>
        </div>
        {subscriptions &&
          subscriptions.map((v, i) => {
            if (v.type === "clock only") {
              return (
                <div className="allSubsViewR2" key={i}>
                  <div className="allSubsType">
                    <span>{v.subscriptionName}</span>
                  </div>
                  <div className="allSubsUsage">
                    <span>
                      {v.durationDays === 0
                        ? "1x use"
                        : v.durationDays + "days"}
                    </span>
                  </div>
                  <div className="allSubsCost">
                    <span>
                      {" "}
                      {v.cost === 0 ? "Free" : "$" + v.cost.toString()}
                    </span>
                  </div>
                  {v.durationDays === 0 ? null : (
                    <button
                      className="deleteUserBtn"
                      onClick={() => {
                        toggleDelete(v._id);
                        handleDelete(v._id);
                      }}
                    >
                      <Delete className="deleteBtnIcon" />
                    </button>
                  )}
                </div>
              );
            }
          })}
      </div>
      <div className="allSubsView">
        <div className="allSubsViewR1">
          <div className="allSubsName">Clock with Stats</div>
        </div>
        {subscriptions &&
          subscriptions.map((v, i) => {
            if (v.type === "clock with stats") {
              return (
                <div className="allSubsViewR2" key={i}>
                  <div className="allSubsType">
                    <span>{v.subscriptionName}</span>
                  </div>
                  <div className="allSubsUsage">
                    <span>
                      {v.durationDays === 0
                        ? "1x use"
                        : v.durationDays + "days"}
                    </span>
                  </div>
                  <div className="allSubsCost">
                    <span>
                      {" "}
                      {v.cost === 0 ? "Free" : "$" + v.cost.toString()}
                    </span>
                  </div>
                  {v.durationDays === 0 ? null : (
                    <button
                      className="deleteUserBtn"
                      onClick={() => {
                        toggleDelete(v._id);
                        handleDelete(v._id);
                      }}
                    >
                      <Delete className="deleteBtnIcon" />
                    </button>
                  )}
                </div>
              );
            }
          })}
      </div>
      <div className="allSubsViewBtn">
        <div className="allSubsViewR1">
          <button onClick={handleOpen} className="addSubsButton">
            Add Subscription
          </button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="muiModalStyle">
              <text className="modalHeading">ADD A SUBSCRIPTION</text>
              <div>
                <div className="modalInputRow">
                  <text className="modalLabel">Package Name</text>
                  <input
                    className="modalInput"
                    value={initialStateForm.subscriptionName}
                    onChange={(e) =>
                      handleFormChange("subscriptionName", e.target.value)
                    }
                    placeholder="Summers etc"
                  />
                </div>
                <div className="modalInputRow">
                  <text className="modalLabel">Cost</text>
                  <input
                    className="modalInput"
                    value={initialStateForm.cost}
                    onChange={(e) => handleFormChange("cost", e.target.value)}
                    placeholder="$0.99"
                  />
                </div>
              </div>
              <div>
                <div className="modalInputRow">
                  <div className="modalInputRowInner">
                    <text className="modalLabel">Select Type</text>
                    <AddSubscriptionModal
                      setSelectedClockType={handleSelectType}
                      data={clockTypes}
                      onBackdropPress={() => setClockTypeModal(false)}
                    />
                  </div>
                  <input
                    className="modalInput"
                    value={initialStateForm?.type}
                    placeholder="Clock Only"
                    disabled
                  />
                </div>
                <div className="modalInputRow">
                  <text className="modalLabel">Duration</text>
                  <input
                    className="modalInput"
                    placeholder="30(days)"
                    value={initialStateForm.durationDays}
                    onChange={(e) =>
                      handleFormChange("durationDays", parseInt(e.target.value))
                    }
                  />
                </div>
              </div>

              <button className="addSubModalButton" onClick={handleCreate}>
                Add
              </button>
            </Box>
          </Modal>
        </div>
      </div>
    </div>
  );
}
